const URL_PARSE_BASE = "https://example.invalid";

const isLegacyCrazySalesHost = (hostname: string) =>
  /^(?:www|m)(?:-(?:sit|uat))?\.crazysales\.com\.au$/i.test(hostname);

// 防止后端返回的数据携带旧站点的绝对链接，导致跳转到旧站点。
const LEGACY_CRAZYSALES_ORIGIN =
  /(?:https?:)?\/\/(?:www|m)(?:-(?:sit|uat))?\.crazysales\.com\.au(?=[:/?#]|$)/gi;

/**
 * Keep links returned by legacy APIs on the current BestDeals environment.
 */
export function normalizeLegacySiteUrl(url: string): string {
  if (!url) return url;

  try {
    const parsedUrl = new URL(url, URL_PARSE_BASE);

    if (!isLegacyCrazySalesHost(parsedUrl.hostname)) return url;

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return url;
  }
}

/**
 * Convert absolute legacy links embedded in trusted API HTML to same-site links.
 */
export function normalizeLegacySiteHtml(html: string): string {
  return html.replace(LEGACY_CRAZYSALES_ORIGIN, "");
}
